export const keepStripPinned = (stripEl, apply) => {
  if (!stripEl || typeof window === 'undefined') {
    apply()
    return
  }
  const styles = window.getComputedStyle(stripEl)
  const pinnedTop = parseFloat(styles.top) || 0
  const rect = stripEl.getBoundingClientRect()
  const wasPinned = styles.position === 'sticky' && window.scrollY > 0 && Math.abs(rect.top - pinnedTop) <= 1.5
  apply()
  if (!wasPinned) return
  const card = stripEl.parentElement
  if (!card) return
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      const cardTop = card.getBoundingClientRect().top + window.scrollY
      const inset = parseFloat(window.getComputedStyle(card).paddingTop) || 0
      const border = parseFloat(window.getComputedStyle(card).borderTopWidth) || 0
      window.scrollTo({ top: Math.max(0, Math.round(cardTop + inset + border - pinnedTop)), behavior: 'instant' })
    })
  })
}

export default keepStripPinned
